function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var focusState = {
  bg: 'blue.900',
  borderBottomColor: 'blue.600',
  color: 'white !important'
};
export var Steps = {
  baseStyle: {
    container: {
      width: ['100%', 'auto'],
      flexWrap: ['nowrap', 'wrap'],
      alignItems: 'center',
      justifyContent: ['space-between', 'flex-start'],
      bg: ['grey.250', 'transparent'],
      borderRadius: '4px',
      overflow: 'hidden'
    },
    step: {
      bg: 'grey.100',
      maxHeight: ['1rem', 'unset'],
      px: '1rem',
      pt: [0, '6px'],
      pb: [0, '4px'],
      borderBottom: ['0', '4px solid'],
      borderBottomColor: ['grey.300', 'grey.300'],
      color: 'black',
      '.tqc-steps__step-count': {
        px: '5px',
        py: '2px',
        background: 'black'
      },
      '&.tqc-steps__current': {
        borderTopRightRadius: ['base', 'unset']
      },
      '> span': {
        display: ['none', 'inline-block']
      },
      _first: {
        borderTopLeftRadius: ['none', 'base']
      },
      _last: {
        borderTopRightRadius: ['none', 'base']
      },
      _hover: {
        bg: 'blue.150'
      },
      _active: _objectSpread(_objectSpread({}, focusState), {}, {
        boxShadow: 'none',
        outline: 'none',
        borderBottomColor: 'blue.600'
      }),
      _focusVisible: _objectSpread(_objectSpread({}, focusState), {}, {
        boxShadow: '0 0 3px 2px #2182EB'
      }),
      _focus: {
        outline: 'none',
        boxShadow: 'none'
      },
      _disabled: {
        _active: {
          color: 'black !important',
          borderBottomColor: 'gray.300',
          background: 'grey.100'
        }
      }
    }
  },
  variants: {
    active: {
      step: {
        borderBottomColor: ['transparent !important', '#0D1F63 !important'],
        _hover: {
          cursor: 'default',
          color: 'black !important',
          bg: 'grey.100'
        }
      }
    },
    completed: {
      step: {
        bg: ['blue.900', 'grey.100'],
        borderBottomColor: 'blue.600',
        _hover: {
          bg: ['blue.900', 'blue.150']
        }
      }
    }
  }
};